// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/AddProductDialog/AddProductDialog.css */

.add-product-dialog-content {
  flex: 1;
  overflow-y: auto;
  min-height: 0;
}

.search-section {
  margin-bottom: 24px;
}

.search-input-container {
  width: 100%;
}

.search-input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  background-color: var(--color-light-gray);
  border-radius: 8px;
  padding: 0 12px;
  border: 1px solid transparent;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.search-input-wrapper:focus-within {
  border-color: var(--color-primary-green);
  box-shadow: 0 0 0 2px var(--accent-ring);
}

.search-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color-dark-gray);
  margin-right: 8px;
  flex-shrink: 0;
}

.search-input-field {
  flex: 1;
  border: none;
  background: none;
  padding: 12px 0;
  font-size: 16px;
  color: var(--color-black);
  outline: none;
  text-align: left;
}

.search-input-field.active {
  padding-left: 0;
}

.search-input-field::placeholder {
  color: var(--color-dark-gray);
}

.clear-search-button {
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color-dark-gray);
  transition: background-color 0.2s ease;
  flex-shrink: 0;
}

.clear-search-button:hover {
  background-color: var(--color-gray);
}

.products-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 16px;
  padding: 0;
}

/* Responsive design */
@media (max-width: 768px) {
  .products-grid {
    grid-template-columns: 1fr;
    gap: 12px;
  }
  
  .search-input-wrapper {
    padding: 0 8px;
  }
  
  .search-input-field {
    padding: 10px 0;
    font-size: 14px;
  }
}

@media (max-width: 480px) {
  .products-grid {
    gap: 8px;
  }
  
  .search-section {
    margin-bottom: 16px;
  }
}
  `, "",{"version":3,"sources":["webpack://./src/dialogs/AddProductDialog.css"],"names":[],"mappings":"AAAA,yDAAyD;;AAEzD;EACE,OAAO;EACP,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,yCAAyC;EACzC,kBAAkB;EAClB,eAAe;EACf,6BAA6B;EAC7B,wDAAwD;AAC1D;;AAEA;EACE,wCAAwC;EACxC,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,UAAU;AACZ;;AAEA,sBAAsB;AACtB;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;AACF;;AAEA;EACE;IACE,QAAQ;EACV;;EAEA;IACE,mBAAmB;EACrB;AACF","sourcesContent":["/* src/components/AddProductDialog/AddProductDialog.css */\n\n.add-product-dialog-content {\n  flex: 1;\n  overflow-y: auto;\n  min-height: 0;\n}\n\n.search-section {\n  margin-bottom: 24px;\n}\n\n.search-input-container {\n  width: 100%;\n}\n\n.search-input-wrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n  background-color: var(--color-light-gray);\n  border-radius: 8px;\n  padding: 0 12px;\n  border: 1px solid transparent;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n}\n\n.search-input-wrapper:focus-within {\n  border-color: var(--color-primary-green);\n  box-shadow: 0 0 0 2px var(--accent-ring);\n}\n\n.search-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--color-dark-gray);\n  margin-right: 8px;\n  flex-shrink: 0;\n}\n\n.search-input-field {\n  flex: 1;\n  border: none;\n  background: none;\n  padding: 12px 0;\n  font-size: 16px;\n  color: var(--color-black);\n  outline: none;\n  text-align: left;\n}\n\n.search-input-field.active {\n  padding-left: 0;\n}\n\n.search-input-field::placeholder {\n  color: var(--color-dark-gray);\n}\n\n.clear-search-button {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 4px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--color-dark-gray);\n  transition: background-color 0.2s ease;\n  flex-shrink: 0;\n}\n\n.clear-search-button:hover {\n  background-color: var(--color-gray);\n}\n\n.products-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n  gap: 16px;\n  padding: 0;\n}\n\n/* Responsive design */\n@media (max-width: 768px) {\n  .products-grid {\n    grid-template-columns: 1fr;\n    gap: 12px;\n  }\n  \n  .search-input-wrapper {\n    padding: 0 8px;\n  }\n  \n  .search-input-field {\n    padding: 10px 0;\n    font-size: 14px;\n  }\n}\n\n@media (max-width: 480px) {\n  .products-grid {\n    gap: 8px;\n  }\n  \n  .search-section {\n    margin-bottom: 16px;\n  }\n}\n  "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
